import script from "./NewResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewResetPasswordForm.vue?vue&type=style&index=0&id=ea951032&lang=css"

const __exports__ = script;

export default __exports__